import { config } from '../../config'
import { PasswordRecoveryResult } from './data-types'


export const sendRecoveryEmail = async (email: string, language: string): Promise<PasswordRecoveryResult> => {
    try {
        const res = await fetch(`${config.api.urlV1}/user/password/forgot/`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                "locale": language,
            },
            body: JSON.stringify({
                email,
            })
        })

        if (res.status !== 200) {
            return {
                error: "Error sending recovery email"
            }
        }

        return {}
    } catch (e) {
        return {
            error: e as string
        }
    }
}